import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/dagpbq1tto0ceqqni2g0";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honey = String(data.get("website_alt") || "").trim();
    if (honey) {
      setStatus("success");
      setMessage("已收到订阅请求，感谢关注海角爆！");
      return;
    }

    setStatus("loading");
    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || "";
      const spamLike = /spam|form data is spam/i.test(serverMsg);
      if (res.ok && parsed?.code === "OK" && !spamLike) {
        setStatus("success");
        setMessage("订阅成功！新鲜快讯将第一时间推送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  }

  return (
    <div className="mx-auto max-w-2xl">
      <form
        onSubmit={onSubmit}
        data-readdy-form="快讯订阅 Newsletter"
        className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-2"
      >
        <label className="relative flex-1">
          <span className="sr-only">你的邮箱</span>
          <i className="ri-mail-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400"></i>
          <input
            type="email"
            name="email"
            required
            placeholder="输入邮箱，订阅每日快讯"
            className="h-12 w-full rounded-md border border-background-200 bg-background-50 pl-11 pr-4 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </label>
        <button
          type="submit"
          disabled={status === "loading"}
          className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 hover:bg-primary-600 disabled:opacity-70"
        >
          {status === "loading" ? (
            <span className="flex items-center gap-2"><i className="ri-loader-4-line animate-spin"></i> 提交中</span>
          ) : (
            <span className="flex items-center gap-2"><i className="ri-send-plane-line"></i> 免费订阅</span>
          )}
        </button>
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="cap-hp-field"
        />
      </form>
      {status === "success" && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-accent-700">
          <i className="ri-checkbox-circle-fill"></i> {message}
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-600">
          <i className="ri-error-warning-line"></i> {message}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">
        <i className="ri-shield-check-line mr-1 text-accent-600"></i>我们重视隐私，可随时退订。订阅即代表同意接收海角爆快讯邮件。
      </p>
    </div>
  );
}